import {FC, useEffect, useState} from "react";
import {useForm, useWatch} from "react-hook-form";
import {FormSingleProps} from "../pages/FormSinglePage";
import {useFetchCurrentEvent} from "../hooks";
import {
    AdditionalServiceDto,
    FeeTypeDto,
    AccommodationTypeDto,
} from "../types/contracts";
import {FormInputs} from "./shared";
import {FormField} from "../types/enums";

export const FormSingle: FC<FormSingleProps> = ({onFormChange}) => {
    const {event, isPending} = useFetchCurrentEvent();

    const [feeTypes, setFeeTypes] = useState<FeeTypeDto[]>([]);
    const [dates, setDates] = useState<string[]>([]);
    const [additionalServices, setAdditionalServices] = useState<
        AdditionalServiceDto[]
    >([]);
    const [accommodations, setAccommodations] = useState<AccommodationTypeDto[]>(
        []
    );

    useEffect(() => {
        if (!event) return;

        setFeeTypes(event.feeTypes);
        setDates(event.dates);
        setAdditionalServices(event.additionalServices);
        setAccommodations(event.accommodations);
    }, [event]);

    const {
        register,
        control,
        formState: {errors, isValid},
        unregister,
        watch,
    } = useForm({mode: "onChange"});

    const [
        name,
        lastName,
        email,
        address,
        birthDate,
        idNumber,
        accommodationType,
        participationFee,
        phoneNumber,
        membershipNumber,
        stayDatesMultiple,
        additionalServ,
        feeTypeId,
        nameOfAccommodation,
        placeOfAccommodation,
    ] = useWatch({
        control,
        name: [
            FormField.Name,
            FormField.LastName,
            FormField.Email,
            FormField.Address,
            FormField.BirthDate,
            FormField.IdNumber,
            FormField.AccommodationType,
            "participationFee",
            FormField.PhoneNumber,
            FormField.MembershipNumber,
            FormField.StayDatesMultiple,
            "additionalServices",
            "feeTypeId",
            FormField.NameOfAccommodation,
            FormField.PlaceOfAccommodation,
        ],
    });

    const defaultVisibleFields = [
        FormField.Name,
        FormField.LastName,
        FormField.Email,
        FormField.FeeType,
    ];
    const [visibleFields, setVisibleFields] =
        useState<FormField[]>(defaultVisibleFields);

    useEffect(() => {
        onFormChange({
            name,
            lastName,
            email,
            address,
            dateOfBirth: birthDate,
            identityCardNumber: idNumber,
            accommodationTypeName:
                accommodations?.find((a) => a.id === accommodationType)?.name ?? "",
            participationFee,
            phoneNumber,
            membershipCardNumber: membershipNumber,
            stayDates: stayDatesMultiple,
            additionalServicesIds: Array.isArray(additionalServ)
                ? additionalServ
                : [],
            feeTypeId,
            eventId: event?.id ?? "",
            eventName: event?.name ?? "",
            customAccommodationName: nameOfAccommodation,
            customAccommodationAddress: placeOfAccommodation,
            isValid,
            feeTypeName: feeTypes?.find((ft) => ft.id === feeTypeId)?.name ?? "",
            accommodationId: accommodationType,
            additionalServices: (event?.additionalServices ?? []).filter(
                (service) =>
                    Array.isArray(additionalServ)
                        ? additionalServ.includes(service.id)
                        : false
            ),
        });
    }, [
        name,
        lastName,
        email,
        address,
        birthDate,
        idNumber,
        accommodationType,
        participationFee,
        phoneNumber,
        membershipNumber,
        stayDatesMultiple,
        additionalServ,
        feeTypeId,
        nameOfAccommodation,
        placeOfAccommodation,
        isValid,
        event,
        accommodations,
        feeTypes,
        additionalServ,
    ]);

    return (
        <form className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
            {isPending && <div>Načítám data události...</div>}
            <FormInputs
                register={register}
                unregister={unregister}
                dates={dates}
                additionalServices={additionalServices}
                stayDatesMultiple={stayDatesMultiple}
                errors={errors}
                feeTypes={feeTypes}
                visibleFields={visibleFields}
                defaultVisibleFields={defaultVisibleFields}
                setVisibleFields={setVisibleFields}
                accommodationType={accommodationType}
                accommodations={accommodations}
                watch={watch}
            />
        </form>
    );
};
